import {GetSelfServiceFlowSectionResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/help_center/v1/service.types';
import {useTrackOriginClick} from '@aboutyou/tracking';
import {COLORS, Text, UnstyledLink} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {ArrowButton} from '../shared/ArrowButton';

interface SelfServiceFlowFooterViewProps {
  contactUs?: GetSelfServiceFlowSectionResponse['contactUs'];
}

export const SelfServiceFlowFooterView = ({
  contactUs,
}: SelfServiceFlowFooterViewProps) => {
  const trackOriginClick = useTrackOriginClick()('selfservice_contact_us');

  if (contactUs == null) {
    return null;
  }
  return (
    <Wrapper>
      <Container>
        <UnstyledLink
          onClick={trackOriginClick}
          to={contactUs.linkTarget.url}
          aria-label={undefined}
        >
          <ArrowButton>
            <Text dangerouslySetInnerHTML={{__html: contactUs.label}} />
          </ArrowButton>
        </UnstyledLink>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  border-top: 1px solid ${COLORS.Grey3};
`;

const Container = styled.div`
  max-width: 430px;
  padding: 60px 20px;
  padding-top: 40px;
`;
